import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { spacer24 } from '@spotify-internal/encore-foundation';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { cssColorValue, cssSpacing, rootStyle, semanticColors } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
var HorizontalRuleElement = styled.hr.withConfig({
  displayName: "HorizontalRule__HorizontalRuleElement",
  componentId: "sc-198gjx4-0"
})(["", ";border:0;border-block-start:1px solid ", ";margin-block-end:", ";margin-block-start:", ";"], rootStyle(), cssColorValue(semanticColors.decorativeSubdued), cssSpacing('plus-1', spacer24), cssSpacing('plus-1', spacer24));

/**
* **HorizontalRule** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/HorizontalRule) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=3755:6810)
*
* HorizontalRule is a thin line that is inserted into flow content to denote a break in the content. without introducing a new section as a heading would.
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/horizontal-rule)
*
* @example
* () => <HorizontalRule />;
*
*/
export var HorizontalRule = function HorizontalRule(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(HorizontalRuleElement, Object.assign({}, props, {
    "data-encore-id": ENCORE_DATA_IDS.HorizontalRule
  }));
};